import { toast } from "react-toastify";
import axiosInstance from "../../../../../axiosInstance";
import { HRMS_EMPLOYEE_API_URL } from "../../../../Constants/baseConstant";
import { getDomain, getUserId } from "../../../Base/helper/baseFunctions";
import NProgress from 'nprogress';


export const GetContractorHelper = async () => {
    NProgress.start()
    return await axiosInstance(`/configuration/getContractor`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain()
        }
    })
        .then((res) => {
            NProgress.done()
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            NProgress.done()
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const AddContractorHelper = async (params) => {
    toast.info("Saving...")
    return await axiosInstance(`/configuration/addContractor`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            name: params?.name,
            address: params?.address,
            contact_person: params?.contact_person,
            mobile_number: +params?.mobile_number || null,
            office_number: null,
            country_id: null,
            state_id: null,
            city_id: null,
            zip_code: null,
            industry: params?.industry || null,
            about_company: null,
            website: null,
            primary_owner: null,
            company_lead_id: null,
            business_unit_id: null,
            email_id: params?.email_id,
            billing_name: params?.billing_name,
            billing_address: params?.billing_address,
            gst_applicable: params?.gst_applicable,
            gst: params?.gst || null,
            cgst: params?.cgst || 9,
            sgst: params?.sgst || 9,
            igst: params?.igst || "0",
            hsn: params?.hsn || null,
            sac_code: params?.sac_code || null,
            status: params?.status,
            is_same: params?.is_same || false,
            lut_ref_no: params?.lut_ref_no || null,
            tds_percentage: params?.tds_percentage || "0",
            bdm_emp_id: null,
            processing_fee_percentage: params?.processing_fee_percentage || "0"
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Contractor added successfully")
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message)
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const UpdateContractorHelper = async (params) => {
    toast.info("Saving...")
    return await axiosInstance(`/configuration/updateContractor`, {
        method: "PUT",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            contractors_fk: params?.contractor_id,
            name: params?.name,
            address: params?.address,
            contact_person: params?.contact_person,
            mobile_number: +params?.mobile_number || null,
            office_number: params?.office_number || null,
            country_id: +params?.country_id?.country_id || null,
            state_id: +params?.state_id?.state_id || null,
            city_id: +params?.city_id?.city_id || null,
            zip_code: params?.zip_code || null,
            industry: params?.industry || null,
            about_company: params?.about_company || null,
            website: params?.website || null,
            primary_owner: params?.primary_owner || null,
            company_lead_id: params?.company_lead_id || null,
            business_unit_id: +params?.business_unit_id || null,
            email_id: params?.email_id,
            billing_name: params?.billing_name,
            billing_address: params?.billing_address,
            gst_applicable: params?.gst_applicable,
            gst: params?.gst || null,
            cgst: params?.cgst || null,
            sgst: params?.sgst || null,
            igst: params?.igst || "0",
            hsn: params?.hsn || null,
            sac_code: params?.sac_code || null,
            is_same: params?.is_same || false,
            lut_ref_no: params?.lut_ref_no || null,
            tds_percentage: params?.tds_percentage || "0",
            bdm_emp_id: params?.employee_id?.employee_id || null,
            processing_fee_percentage: params?.processing_fee_percentage
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Contractor Updated successfully")
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message)
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}


export const DeleteContractorHelper = async (params) => {
    toast.info("Deleting...")
    return await axiosInstance(`/configuration/deleteContractor`, {
        method: "DELETE",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            contractors_fk: params?.contractor_id,
            status: params?.status
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Contractor Deleted Successfully");
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message)
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}
